const url = 'https://kind-pink-anemone-tutu.cyclic.app/getDetailsShippingByType/'

function getShippingPrice(type, setShippingPrice) {
    fetch(`${url}${type}`).then(response => {
        if (response.ok) {
            return response.json()
        }
        throw response
    }).then(data => {
        if(data.shipping.length == 0){
            setShippingPrice(0)
        }else{
            setShippingPrice(data.shipping[0].shipping_price)
        }
    })
}

export default getShippingPrice